<template>
  <app-modal
    v-bind="$attrs"
    class="confirm-modal-container"
    content-class="modal-error"
    ref="modal"
    :title="isLoginPage ? 'エラー' : 'セッションタイムアウト'"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <div class="modal-body text-pre-wrap pa-4">
        <template v-if="isLoginPage">
          {{ error.data.errorMessage }}
        </template>
        <template v-else>
          ー定時間操作がありませんでしたので、安全のために接続を切りました。再度ログインし直してください。
        </template>
      </div>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              v-if="isLoginPage"
              variant="outlined"
              color="primary"
              @click="cancel"
              >閉じる</v-btn
            >
            <v-btn v-else variant="flat" color="primary" @click="ok"
              >ログイン画面</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { ApiRequestError } from "@/error/errors";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "UnauthorizedErrorModal",
  props: {
    /** エラー */
    error: {
      type: ApiRequestError as PropType<ApiRequestError>,
      required: true,
    },
  },
  computed: {
    /** true: 現在ログインページ, false: ログインページではない */
    isLoginPage(): boolean {
      return this.$route.path === "/login";
    },
  },
  methods: {
    async ok() {
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      await this.$store.dispatch("user/logout");
      await this.$router.push({ path: "/login" });
    },
  },
});
</script>
